import { decryptAES256 } from "api/api";
import React, { useEffect } from "react";

const Viewer: React.FC = () => {
  const viewer = async () => {
    const searchParams = new URLSearchParams(window.location.search);
    const aesParameter = searchParams.get('recorderInfo') || "";
    
    const REACT_APP_SECRET_KEY = process.env.REACT_APP_SECRET_KEY!;
    const REACT_APP_SECRET_IV = process.env.REACT_APP_SECRET_IV!;
    
    if (!aesParameter) {
      alert('Invalid Value');
      window.close();
    }
    
    const decryptedParameter = decryptAES256(
      decodeURIComponent(aesParameter),
      REACT_APP_SECRET_KEY!,
      REACT_APP_SECRET_IV!
    );
    
    const recorderInfo = new URLSearchParams(decryptedParameter);
    const parseParam = (key: string): string => {
      const value = recorderInfo.get(key);
      return value ? value.replaceAll(' ', '+') : ""; // ' ' -> '+' 변환 적용
    };
    
    const serialNumber = parseParam('mac');
    const ip = parseParam('ip');
    const port = parseParam('port');
    const channel = parseParam('channel');
    const currentChannel = Number(parseParam('currentChannel'));
    
    const aesId = parseParam('id');
    const aesPassword = parseParam('password');
    const id = decryptAES256(aesId, REACT_APP_SECRET_KEY!, REACT_APP_SECRET_IV!);
    const password = decryptAES256(aesPassword, REACT_APP_SECRET_KEY!, REACT_APP_SECRET_IV!);
    const isValidIp = (ip: string): boolean => /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}$/.test(ip);
    
    if (!isValidIp(ip)) {
      alert('Invalid IP address');
      window.close();
    }

    const spinner = document.querySelector('#qtspinner');
    const canvas = document.querySelector('#screen');
    const status = document.querySelector('#qtstatus');
    if (spinner && canvas && status && password) {
      // ------------------------------------ (2) qtLoader를 실행시킨다.
      window.init(() => {
        // 기기 정보 설정
        window.uWebSetSiteInfo(serialNumber, ip, port, port, channel);
  
        // 기기 정보 설정
        window.uWebSetUserInfo(id, password);
  
        // 타이틀바 없애기
        window.uWebTitleBarShowHide(false);
  
        if (currentChannel === 0) {
          // 전체 채널 LIVE 재생
          window.uWebSetLiveAllOpen();
        } else {
          window.uWebSetLiveOpen(String(currentChannel - 1));
        }
      });
    }
  };

  useEffect(() => {
    // opener(부모 창)가 존재하는지 확인
    if (window.opener && window.opener.location.protocol === "https:") {
      console.log("부모 창은 HTTPS, 현재 팝업은 HTTP");
    }
  
    // 현재 창이 HTTPS로 열렸다면 HTTP로 다시 리디렉트
    if (window.location.protocol === "https:") {
      window.location.replace(`http://${window.location.host}${window.location.pathname}${window.location.search}`);
    } else {
      viewer();
    }
  }, []);
  return (
    <>
      <figure style={{ overflow: 'visible' }} id="qtspinner">
        <center style={{ marginTop: '1.5em', lineHeight: '150%' }}>
          <img src="/PrismWebViewer/qtlogo.svg" width="320" height="200" style={{ display: 'block' }} alt="qt logo" />
          <strong>Qt for WebAssembly: UMiniWebViewer</strong>
          <div id="qtstatus"></div>
          <noscript>JavaScript is disabled. Please enable JavaScript to use this application.</noscript>
        </center>
      </figure>

      <div id="screen" style={{height:'100%'}}></div>
    </>
  )
};

export default Viewer;